import { isNotNullOrUndefined } from "@smart/itops-utils-basic";
import { Gql } from "@smart/manage-gql-operations-dom";

export type Branding = Gql.SettingFieldsFragment["branding"];
export type BrandingInput = NonNullable<
  Gql.UpdateSettingMutationVariables["fields"]["branding"]
>;

export const getDefaultValues = (branding?: Branding): BrandingInput => ({
  brandColor: branding?.brandColor || undefined,
  affectedAreas: {
    headerBackground: branding?.affectedAreas?.headerBackground || false,
    headerUnderline: branding?.affectedAreas?.headerUnderline || false,
    firmName: branding?.affectedAreas?.firmName || false,
    sectionTabHighlights:
      branding?.affectedAreas?.sectionTabHighlights || false,
    sectionHeadings: branding?.affectedAreas?.sectionHeadings || false,
    buttons: branding?.affectedAreas?.buttons || false,
  },
  headerTextColor: branding?.headerTextColor || "default",
  backgroundColor: branding?.backgroundColor || "default",
  headerDisplay: {
    firmLogo: isNotNullOrUndefined(branding?.headerDisplay?.firmLogo)
      ? branding?.headerDisplay?.firmLogo
      : true,
    firmName: isNotNullOrUndefined(branding?.headerDisplay?.firmName)
      ? branding?.headerDisplay?.firmName
      : true,
  },
  buttonRadius: branding?.buttonRadius || "moderatelyRounded",
  inputRadius: branding?.inputRadius || "moderatelyRounded",
  logo: branding?.logo || undefined,
});
